import React, { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { selectRectangleSelection } from 'selectors/scheduler';
import { SelectionButton } from './styles';
import { toggleRectangleSelection } from 'actions/schedulerActions';
import HighlightAlt from '../../../../../assets/images/icons/highlight_alt.svg';
import {Tooltip} from "@hub-mono/ui";

export const SchedulerSelectionButton = () => {
    const dispatch = useDispatch();
    const rectangleSelection = useSelector(selectRectangleSelection);
    const [shiftOn, setShiftOn] = useState(false);

    useEffect(() => {
        if (!rectangleSelection) {
            const keyDownHandler = event => {
                if (event.key === 'Shift') {
                    event.preventDefault();
                    setShiftOn(true);
                }
            };

            const keyUpHandler = event => {
                if (event.key === 'Shift') {
                    event.preventDefault();
                    setShiftOn(false);
                }
            };

            document.addEventListener('keydown', keyDownHandler);
            document.addEventListener('keyup', keyUpHandler);

            return () => {
                document.removeEventListener('keydown', keyDownHandler);
                document.removeEventListener('keyup', keyUpHandler);
            };
        }
    }, [dispatch, rectangleSelection]);

    return (
        <Tooltip title="Multi select bookings (Hold Shift + Click)" placement="top">
            <SelectionButton
                data-cy="scheduler-multiselect-btn"
                onClick={e => {
                    if (rectangleSelection) window.schedulerRef.current?.control?.multiselect?.clear();
                    if (!shiftOn) {
                        dispatch(toggleRectangleSelection.request());
                    }
                    e.currentTarget.blur();
                }}
                className={`center ml-2 ${(rectangleSelection || shiftOn) && 'active'}`}
                color=""
            >
                <HighlightAlt />
            </SelectionButton>
        </Tooltip>
    );
};
